import { http } from 'services/http';
import { TRIP_TASKS_GET_MANY } from 'api/query-keys';
import type { TAddCargoToTripTaskReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IAddCargoToTripTaskVariables extends TAddCargoToTripTaskReq {
  tripTaskId: number;
}

export const useAddCargoToTripTask = (tripId: number) => {
  return useMutationBase<unknown, unknown, IAddCargoToTripTaskVariables>({
    mutationFn: async (variables) => {
      await http.patch(`/v1/trips/${tripId}/trip-tasks/${variables.tripTaskId}/cargo-trips`, {
        cargoTripIds: variables.cargoTripIds,
      });
    },
    invalidateCallback: () => [[TRIP_TASKS_GET_MANY, tripId]],
  });
};
